/**
 * drillPresentation.js — shared detection helpers for the 2.5D presentation layer.
 *
 * PRINCIPLE: edit in 2D, present in 2.5D. These helpers detect what a drill
 * actually contains so Desktop (ExerciseDetail) and Mobile (TrainingMobileView)
 * use the EXACT same rules — no view-specific drift.
 *
 * Two animation data models are supported (both render via Pitch25DView):
 *   1) Multi-step snapshot model (seed/gold_v2): data.steps = [{objects}, ...]
 *   2) Timeline/movement model (2D editor V2):   data.steps = [base] + data.movements = [...]
 */

// Does this snapshot/diagram data contain any drawable objects?
export const dataHasObjects = (d) => !!(d && (
  (Array.isArray(d.steps) && d.steps[0]?.objects?.length > 0) ||
  (Array.isArray(d.objects) && d.objects.length > 0) ||
  (Array.isArray(d.staticArrows) && d.staticArrows.length > 0)
));

// Does this data describe real MOVEMENT (so it must play, with controls)?
// True for multi-step snapshots OR a movements/timeline array.
export const dataHasAnimation = (d) => !!(d && (
  (Array.isArray(d.movements) && d.movements.length > 0) ||
  (Array.isArray(d.steps) && d.steps.length > 1)
));

// Is this an exercise-detail route (the mobile page that hosts the 2.5D
// presentation)? Used to hide the global MobileBottomNav so it can't overlap
// the presentation control dock, and to drop the obsolete nav bottom padding.
// Matches:  /training/library/:exerciseId
//           /training/session/:sessionId/exercise/:exerciseId
export const isExerciseDetailRoute = (pathname) => {
  const p = String(pathname || '');
  return /^\/training\/library\/[^/]+\/?$/.test(p) ||
         /^\/training\/session\/[^/]+\/exercise\/[^/]+\/?$/.test(p);
};
